import singleCardEdit from '@/entities/insights/modal/edit-reference/single-card-edit/single-card-edit.vue';
import { documentCard } from '@/shared/model/document-card.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'report-text',
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
    'single-card': singleCardEdit,
  },
})
export default class reportText extends Vue {
  item = new documentCard();
  scrollSettings = {
    wheelPropagation: false,
  };
  isShowSpinner = false;
  checked = false;
  totalSelected = 0;
  selectedItems = [];
  allItem = [];

  @Watch('selectedItems')
  watchSelectedItems() {
    this.totalSelected = this.selectedItems.length;
  }

  setSelectedItems(newData) {
    this.selectedItems = newData;
    this.totalSelected = this.selectedItems.length;
  }

  selectAll() {
    if (this.selectedItems.length === this.allItem.length) this.selectedItems = [];
    else this.selectedItems = this.allItem;
  }

  deleteAll() {
    this.selectedItems.splice(0, this.selectedItems.length);
  }

  addToArr() {
    if (this.item.content && this.item.title) {
      const obj = this.allItem.find(element => element.content == this.item.content && element.title == this.item.title);
      if (obj) return;
      this.item.author = 'Text';
      this.item.keyword = '';
      this.item.type = 'USERNOTE';
      this.item.searchType = 'USERNOTE';
      this.item.addedAt = new Date().toISOString();
      this.item.url = '';
      this.item.images = [];
      this.item.favicon = null;
      this.item.typeRemove = 'text';
      const itemPush = Object.assign(new documentCard(), this.item);
      this.allItem.push(itemPush);
      this.selectedItems.push(itemPush);
      this.item = new documentCard();
    }
  }

  refresh() {
    this.item.content = '';
    this.item.title = '';
  }

  removeCardReq(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) this.selectedItems.splice(index, 1);
  }

  resetListSelected() {
    this.selectedItems.splice(0, this.selectedItems.length);
  }

  removeCardInList(item) {
    const index = this.allItem.indexOf(item);
    if (index !== -1) this.allItem.splice(index, 1);
    this.removeCardReq(item);
  }

  clearModalData() {
    this.allItem.splice(0, this?.allItem?.length);
    this.item = new documentCard();
    this.resetListSelected();
  }
  addToReference() {
    this.$root.$emit('add-to-lst-reference', this.selectedItems, true);
    // @ts-ignore
    window.$('#modal-text-report').modal('hide');
  }

  nextAndPre(next?) {
    next
      ? $('#scroll-div-report-text').append($('#scroll-div-report-text').find('li:first-child'))
      : $('#scroll-div-report-text').append($('#scroll-div-report-text').find('li:last-child'));
  }

  created() {
    this.$root.$on('clear-modal-data-text', this.clearModalData);
  }

  destroyed() {
    this.$root.$off('clear-modal-data-text', this.clearModalData);
  }
}
